import reducer from './reducers';
import * as sharedSelectors from './selectors';
import * as sharedOperations from './operations';
import * as sharedTypes from './types';

export { sharedSelectors, sharedOperations, sharedTypes };

export default reducer;
